export enum ContractContactType {
  Standard = 'Standard',
  Primary = 'Primary',
  Billing = 'Billing',
}

export interface ContractContact {
  id?: number;
  name: string;
  email: string;
  phone: string;
  note: string;
  contact_type: ContractContactType;
}
